import { render, staticRenderFns } from "./PerformanceTemplate.vue?vue&type=template&id=b7f7b124&scoped=true"
import script from "./PerformanceTemplate.vue?vue&type=script&lang=js"
export * from "./PerformanceTemplate.vue?vue&type=script&lang=js"
import style0 from "./PerformanceTemplate.vue?vue&type=style&index=0&id=b7f7b124&prod&lang=css"
import style1 from "./PerformanceTemplate.vue?vue&type=style&index=1&id=b7f7b124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f7b124",
  null
  
)

export default component.exports